import React from 'react';
import ContactForm from "../components/contactForm"
import "../styles/contact.css"

function Contact(props) {
    return (
        <div id="contact-container">
            <h1>
                Get in touch with Hassan Academy
            </h1>
            <br/>
            <p>
                Want to get in touch? We’d love to hear from you. Here’s how you can reach us…
                <br />
            </p>
            <p>
                <b>
                    Interested in our courses? Just pick up the phone and call us.
                </b>
                <br />
                +923137309839
                <br />
                +923454459673
                <br />
            </p>
            <p><b>
                Text Us on Whatsapp

                </b>
                <br />
                Prefer texting? Send us your inquiry through Whatsapp
                <br />
                +923137309839
            </p>
            <p>
                <b>
                    Send us an Email
                </b>
                <br />
                Prefer official form of communications? Send us an email
                <br />
                Hassan.academy@outlook.com
            </p>
            {/* <h1>
                Dummy Contact Form
            </h1> */}
            {/* <ContactForm /> */}
        </div>
    );
}

export default Contact;